import { Box, Typography } from '@mui/material';
import { ModalName } from 'app/enums/modal-name';
import React, { FC } from 'react';
import { Modal } from 'shared/components/Modal';
import { withModalOpenChecker } from 'shared/HOC/withModalOpenChecker';
import { AvailableBalance } from '../AvailableBalance';
import { useStyles } from '../PaymentModal.styles';
import { SummaryLabel } from '../SummaryLabel';
import { ProviderOptions } from '../ProviderOptions';
import { DepositCryptoInstructions } from './DepositCryptoInstructions';
import { CryptoAddress } from '../CryptoAddress';
import { MultiCurrencyConfig } from 'config/multi-currency-config';
import { DEPOSIT_FUNDS_OPTIONS } from 'modules/payments/constants';

const AddFundsModalComponent: FC = () => {
  const { classes } = useStyles();

  const height = MultiCurrencyConfig.isReplenishmentEnabled() ? 790 : 750;

  return (
    <Modal name={ModalName.BalanceAddFunds} title="Add funds" contentHeight={height} maxWidth="md">
      <Box className={classes.root}>
        <AvailableBalance onlyActive />

        <Box mb={2}>
          <Typography mb={2} variant="h6">
            Select a deposit option:
          </Typography>

          <ProviderOptions
            options={DEPOSIT_FUNDS_OPTIONS}
            selected={DEPOSIT_FUNDS_OPTIONS[0].value}
            onChange={() => {}}
            isDisabled={false}
          />
        </Box>

        <Box mb={2}>
          <CryptoAddress />
        </Box>

        <Box>
          <SummaryLabel labelText="Deposit instruction" />
          <DepositCryptoInstructions />
        </Box>
      </Box>
    </Modal>
  );
};

export const AddFundsModal = withModalOpenChecker(
  AddFundsModalComponent,
  ModalName.BalanceAddFunds
);
